// @flow

// State Configuration
export const TREE = 'shapeData'
export const BRANCH = 'shapes'
